'use strict';

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var addLink = require('./add-link.js');

var appendData = require('./append-data.js');

var rmLink = require('./rm-link.js');

var setData = require('./set-data.js');

var ObjectPatchAPI = function ObjectPatchAPI(_ref) {
  var repo = _ref.repo,
      preload = _ref.preload;

  _classCallCheck(this, ObjectPatchAPI);

  this.addLink = addLink.createAddLink({
    repo: repo,
    preload: preload
  });
  this.appendData = appendData.createAppendData({
    repo: repo,
    preload: preload
  });
  this.rmLink = rmLink.createRmLink({
    repo: repo,
    preload: preload
  });
  this.setData = setData.createSetData({
    repo: repo,
    preload: preload
  });
};

exports.ObjectPatchAPI = ObjectPatchAPI;